module.exports = __webpack_public_path__ + "img/m-nex22-menu-desktop.d8d11843.jpg";